import { render, staticRenderFns } from "./tuan.vue?vue&type=template&id=e8c56b1e&"
import script from "./tuan.vue?vue&type=script&lang=js&"
export * from "./tuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports